export class SessionStorage {
	private static dataInstance = new Map<string, string>();

	public static remove(id: string) {
		try {
			window.sessionStorage.removeItem(id);
		} catch (e) {
			console.warn(e);
		}

		SessionStorage.dataInstance.delete(id);
	}

	public static set(id: string, data: string | null | undefined) {
		if (data === null || data === undefined) {
			this.remove(id);
			return;
		}

		try {
			window.sessionStorage.setItem(id, data);
		} catch (e) {
			console.warn(e);
			SessionStorage.dataInstance.set(id, data);
		}
	}

	public static get(id: string): string | undefined {
		let data: string | null | undefined;

		try {
			data = window.sessionStorage.getItem(id);
		} catch (e) {
			console.warn(e);
			data = SessionStorage.dataInstance.get(id);
		}

		if (data === null) return undefined;

		return data;
	}
}
